import type { Creator } from '@/types';
import type { LeaderboardRow } from '../types';
import { filterByPeriod } from '@/utils/period-stats';

export type MotivationalData = {
  weekDiff: number;
  nextRankGap: number | null;
  streak: number;
};

function getLastWeekBounds(): { start: Date; end: Date } {
  const now = new Date();
  const day = now.getDay();
  const diff = day === 0 ? 6 : day - 1;
  const mon = new Date(now);
  mon.setDate(now.getDate() - diff - 7);
  mon.setHours(0, 0, 0, 0);
  const end = new Date(mon);
  end.setDate(mon.getDate() + 7);
  return { start: mon, end };
}

function countLastWeek(creators: Creator[]): number {
  const { start, end } = getLastWeekBounds();
  return creators.filter((l) => {
    const d = new Date(l.created);
    return d >= start && d < end;
  }).length;
}

function computeStreak(creators: Creator[]): number {
  const dates = new Set(
    creators.map((l) => new Date(l.created).toISOString().slice(0, 10))
  );
  let count = 0;
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  while (dates.has(d.toISOString().slice(0, 10))) {
    count++;
    d.setDate(d.getDate() - 1);
  }
  return count;
}

export function computeMotivational(
  creators: Creator[],
  leaderboard: LeaderboardRow[],
  collectorId: string
): MotivationalData {
  const thisWeek = filterByPeriod(creators, 'week').length;
  const sorted = [...leaderboard].sort(
    (a, b) => b.creatorCount - a.creatorCount
  );
  const idx = sorted.findIndex((r) => r.id === collectorId);
  const prev = sorted[idx - 1];
  const curr = sorted[idx];
  const nextRankGap =
    idx > 0 && prev && curr ? prev.creatorCount - curr.creatorCount + 1 : null;
  return {
    weekDiff: thisWeek - countLastWeek(creators),
    nextRankGap,
    streak: computeStreak(creators),
  };
}
